// Status-aware wording for the emailed login link in Login Management.
// Same link either way; someone who has never logged in is activating, not
// resetting.

type LoginRow = { status: string; lastLoginAt: string | null };

export function hasNeverActivated(row: LoginRow): boolean {
  return row.status !== "active" && !row.lastLoginAt;
}

export function loginLinkLabel(row: LoginRow): string {
  return hasNeverActivated(row) ? "Send activation link" : "Send password reset link";
}

/** Label for a bulk send: activation / reset when uniform, neutral when mixed. */
export function bulkLoginLinkLabel(rows: LoginRow[]): string {
  if (rows.length > 0 && rows.every(hasNeverActivated)) return "Send activation link";
  if (rows.some(hasNeverActivated)) return "Send login link";
  return "Send password reset link";
}
